import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  blocksShipping: {
    defaultMessage: 'BLOCKS SHIPPING',
    description: 'Label indicating this rule blocks shipping',
    id: 'px3IBQ',
  },
  flagsForReview: {
    defaultMessage: 'FLAGS FOR REVIEW (does not block)',
    description: 'Label indicating this rule flags orders for review',
    id: '89zFSk',
  },
  informationalOnly: {
    defaultMessage: 'INFORMATIONAL ONLY (does not block)',
    description: 'Label indicating this rule is informational only',
    id: 'F3NRID',
  },
  appliedDateLabel: {
    defaultMessage: 'Applied: {date}',
    description: 'Label showing when indicator was applied',
    id: 'W/dgqj',
  },
  categoryLabel: {
    defaultMessage: 'Category: {category}',
    description: 'Label showing indicator category',
    id: 'cxfVQg',
  },
  detailsLabel: {
    defaultMessage: 'Details',
    description: 'Label for metadata details section',
    id: 'fjnwa2',
  },
  dismissButtonAriaLabel: {
    defaultMessage: 'Dismiss fraud indicator',
    description: 'Aria label for dismiss button on fraud indicator card',
    id: 'RWm6Rj',
  },
  unblockButton: {
    defaultMessage: 'Unblock and Remove Alert',
    description: 'Button text to unblock a blocking fraud indicator',
    id: 'klphz7',
  },
  removeAlertButton: {
    defaultMessage: 'Remove Alert',
    description: 'Button text to remove a non-blocking fraud indicator',
    id: 'ORJ6ee',
  },
  dismissSuccess: {
    defaultMessage: 'Fraud indicator dismissed',
    description: 'Success notification when fraud indicator is dismissed',
    id: 'adQsQY',
  },
  dismissError: {
    defaultMessage: 'Failed to dismiss fraud indicator',
    description: 'Error notification when dismissal fails',
    id: '+E1iGA',
  },
  indicatorWithMatchScore: {
    defaultMessage: '{name} ({score}% match)',
    description: 'Fraud indicator name with fuzzy match score percentage',
    id: '7U19OX',
  },
});
